document.addEventListener('DOMContentLoaded', function () {

  /* ---------- header scroll state ---------- */
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var burger = document.getElementById('burgerBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
    });
  }

  /* ---------- reduced motion ---------- */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger, .thread-divider');
  if (prefersReducedMotion) {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- product tabs (Men / Women / Sale) ---------- */
  var tabBtns = document.querySelectorAll('.tab-btn');
  if (tabBtns.length) {
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var target = btn.dataset.tab;
        document.querySelectorAll('.product-grid').forEach(function (grid) {
          if (grid.dataset.tabPanel === target) {
            grid.hidden = false;
            grid.classList.remove('in');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { grid.classList.add('in'); });
            });
          } else {
            grid.hidden = true;
          }
        });
      });
    });
  }

  /* ---------- gallery thumbs on product page ---------- */
  var galleryMain = document.getElementById('galleryMain');
  document.querySelectorAll('.gallery-thumbs .thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumbs .thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (galleryMain && t.dataset.fullImage) {
        galleryMain.style.backgroundImage = 'url(' + t.dataset.fullImage + ')';
        galleryMain.classList.remove('no-image');
      }
    });
  });

  /* =========================================================
     QUANTITY STEPPER + BUY BUTTONS
     Each [data-buy-block] has its own qty stepper. Add to Cart
     adds via AJAX and goes to /cart. Instant Buy adds via AJAX
     and goes straight to Shopify's native /checkout, which
     collects phone, address and payment method automatically.
  ========================================================= */
  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    return 'Rs. ' + amount.toLocaleString('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  document.querySelectorAll('[data-buy-block]').forEach(function (block) {
    var unitPrice = parseInt(block.dataset.unitPrice, 10) || 0;
    var variantId = block.dataset.variantId;
    var qtyValueEl = block.querySelector('[data-qty-value]');
    var qtyTotalEl = block.querySelector('[data-qty-total]');
    var minusBtn = block.querySelector('[data-qty-minus]');
    var plusBtn = block.querySelector('[data-qty-plus]');
    var noteEl = block.querySelector('[data-buy-note]');
    var triggerBtns = block.querySelectorAll('.buy-trigger');
    var qty = 1;

    function renderQty() {
      if (qtyValueEl) qtyValueEl.textContent = qty;
      if (qtyTotalEl) qtyTotalEl.textContent = formatMoney(unitPrice * qty);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        renderQty();
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        qty = Math.min(99, qty + 1);
        renderQty();
      });
    }
    renderQty();

    triggerBtns.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        if (!variantId) {
          if (noteEl) noteEl.textContent = "This product isn't available right now.";
          return;
        }

        var mode = btn.dataset.buyAction === 'checkout' ? 'checkout' : 'cart';
        triggerBtns.forEach(function (b) { b.disabled = true; });
        if (noteEl) { noteEl.textContent = mode === 'checkout' ? 'Preparing checkout…' : 'Adding to cart…'; noteEl.classList.remove('error'); }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw err; }); }
            return res.json();
          })
          .then(function () {
            window.location.href = mode === 'checkout' ? '/checkout' : '/cart';
          })
          .catch(function (err) {
            if (noteEl) {
              noteEl.textContent = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
              noteEl.classList.add('error');
            }
            triggerBtns.forEach(function (b) { b.disabled = false; });
          });
      });
    });
  });
});
